module.exports = __webpack_public_path__ + "img/icon_element.5146ca69.svg";